// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:600px){[data-test=sign-up-section]{padding:0;padding-right:.5rem;margin:0;min-width:0}[data-test=sign-in-section]{padding:0;padding-right:.5rem;margin:0;min-width:0}[data-test=confirm-sign-up-section]{padding:0;padding-right:.5rem;margin:0;min-width:0}[data-test=sign-in-footer-section]{padding:0;margin:0;-ms-flex-direction:row;flex-direction:row}[data-test=sign-in-footer-section] span{margin-left:0}}.auth-content-rotate{transform:rotate(-7deg);overflow:hidden}", ""]);
// Exports
module.exports = exports;
